import React from 'react';
import * as firebase from 'firebase/app';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ButtonBase from '@material-ui/core/ButtonBase';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import { oc } from 'ts-optchain';
import { useIntl, FormattedMessage } from 'react-intl';
import commonMessages from 'messages/common';
import { User } from 'models';

const useStyles = makeStyles(theme => ({
  avatar: {
    backgroundColor: theme.palette.secondary.main,
    width: 33,
    height: 33,
    marginRight: theme.spacing(1),
    color: 'black'
  },
  menu: {
    maxWidth: 250,
    width: '100%'
  },
  button: {
    backgroundColor: theme.palette.primary.dark,
    padding: '6px 8px',
    borderRadius: 22
  }
}));

interface LoginAvatarProps {
  currentUser: User;
}

const LoginAvatar: React.FC<LoginAvatarProps> = ({ currentUser }) => {
  const intl = useIntl();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function logout() {
    firebase.auth().signOut();
    window.location.reload();
  }
  const username = oc(currentUser).profile.username('');
  const avatar_url = oc(currentUser).profile.avatar_url('');

  const avatar = (
    <Avatar alt={username} src={avatar_url} className={classes.avatar}>
      {(username[0] || '').toUpperCase()}
    </Avatar>
  );
  return (
    <>
      <Hidden smUp>
        <IconButton onClick={handleClick}>{avatar}</IconButton>
      </Hidden>

      <Hidden xsDown>
        <ButtonBase
          className={classes.button}
          aria-controls="profile-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          {avatar}
          <Typography>
            <FormattedMessage
              id="Header.LoginAvatar.username"
              defaultMessage="{username} 님"
              description="{username} 님"
              values={{
                username
              }}
            />
          </Typography>
        </ButtonBase>
      </Hidden>

      <Menu
        id="profile-menu"
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {/* <MenuItem component={AdapterLink} to="/dashboard">
          <FormattedMessage
            id="Header.LoginAvatar.list.link"
            defaultMessage="리스트"
            description="List"
          />
        </MenuItem> */}
        <MenuItem onClick={logout}>
          {intl.formatMessage(commonMessages.signout)}
        </MenuItem>
      </Menu>
    </>
  );
};
export default LoginAvatar;
